// extracted by mini-css-extract-plugin
export default {"messageIcon":"zypLsPCqYNXeuo28iMjy","MessageUserButton":"B_hnziuElg4SejaN3eLi","defaultButton":"SO_KEA5pgZ06Pmq7YdaA","linkButton":"OxXeHGMNeJOTyTxKOPAn"};